import TYPES from '@/modules/shared/types';

// Domain
import { LinkSowosWealthRepository } from '../../domain/repositories/link-sowos-wealth-repository';
import { InvestorGoalsDto } from '../../domain/dtos/investor-goals-dto';
import {
  LinkInvestorGoalsDto,
} from '@/modules/flagship/investor-goal/link-sowos-wealth/domain/dtos/link-investor-goals-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class LinkSowosWealthHttpRepository implements LinkSowosWealthRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/link-sowos-wealth/`;

  private readonly endpoint_v2 = `${process.env.VUE_APP_API_URL}/api/v2/app/flagship/investor-goal/link-sowos-wealth/`;

  create(investor_goals_dto: InvestorGoalsDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', investor_goals_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }

  link_goals(payload: LinkInvestorGoalsDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint_v2, 'POST', payload)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
